import React from "react";
import { Row, Col } from "antd";
import NFTMintingForm from "./NFTMintingForm";
import NFTBalance from "./NFTBalance";
import { useMoralis } from "react-moralis";
import { useState, useEffect } from "react";

export default function Dashboard() {
 
  const { account, isAuthenticated, user  } = useMoralis();
  const [accountAddress, setAccountAddress] = useState('');
  useEffect(() => {
    if (isAuthenticated && accountAddress?.toLowerCase() !== account?.toLowerCase()) {
      setAccountAddress(account);
    }
    if (!isAuthenticated) {
      setAccountAddress('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, account, isAuthenticated, accountAddress]);

  return (
    <div>
      <Row>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <NFTMintingForm/>
        </Col>

        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <NFTBalance AddressInput={accountAddress}/>
        </Col>
      </Row>
    </div>
  );
}
